import { renderClassName } from "@/utils/renderClassName";

type SectionProps = {
  isFullHeight?: "full" | "double-full";
  element?: "div";
  children: React.ReactNode;
  className?: string;
  isLargeTopPadding?: boolean;
  isLargeBottomPadding?: boolean;
  isPaddingTop?: boolean;
  isPaddingBottom?: boolean;
  isSmallTopPadding?: boolean;
  isSmallBottomPadding?: boolean;
  id?: string;
};

const Section = ({
  isFullHeight,
  element,
  className,
  isLargeTopPadding,
  isLargeBottomPadding,
  isPaddingTop,
  isPaddingBottom,
  isSmallTopPadding,
  isSmallBottomPadding,
  id,
  children,
}: SectionProps) => {
  const Element = element || "section";

  return (
    <Element
      id={id}
      style={{
        minHeight: isFullHeight
          ? isFullHeight === "full"
            ? "100dvh"
            : "200dvh"
          : "fit-content",
      }}
      className={renderClassName("section", className)
        .concat(isLargeTopPadding ? " section--large-top-padding" : "")
        .concat(isLargeBottomPadding ? " section--large-bottom-padding" : "")
        .concat(isSmallTopPadding ? " section--small-top-padding" : "")
        .concat(isSmallBottomPadding ? " section--small-bottom-padding" : "")
        .concat(isPaddingTop ? " section--top-padding" : "")
        .concat(isPaddingBottom ? " section--bottom-padding" : "")
        .trim()}
    >
      {children}
    </Element>
  );
};

export default Section;
